import { tAttr } from '../services/utils'

export const ng = app => {
  app.filter('evaTAttr', () => tAttr);
  app.directive('evaTAttr', () => ({
    link: (scope, element, attrs) => scope.$watch(attrs.evaTAttr, value => element.text(tAttr(value)))
  }));
}
